import React from 'react';
import { loadProvider, deleteProvider } from '../../../api/list'
import PageList from '../../../components/PageListAPI'
import { useCan } from '../../../hooks/useCan';
import { SLUGS } from '../../../enum/permissions.enum';


export default function Provider(props) {
  const can = useCan()
  return (
    <div className='App-paper'>
      <PageList
        name='provider'
        title='Поставщики материалов и оборудования'
        columns={[{ id: 'inn', name: 'ИНН', width:'15%' }, { id: 'name', name: 'Название' }]}
        createItem={can(SLUGS.CATALOG.PROVIDER.MANAGE)}
        deleteItem={can(SLUGS.CATALOG.PROVIDER.MANAGE)}
        loadAPI={{
          request: loadProvider,
        }}
        deleteAPI={deleteProvider}
        {...props}
      />
    </div>
  )
}